import { MFS_MEASUREMENT_VIEW_FLAG } from '@/services/settlement/settlementManagement/types'
import { useFeatureFlagBoolean } from '@/services/feature/useFeatureQueries'

// LOGISPRD-16794 실측비 노출 flag 를 읽는 곳은 여기 하나다. 조회 전·실패는 false(현행 화면)
export const useMeasurementSettlementEnabled = (): boolean => {
  const { data } = useFeatureFlagBoolean(MFS_MEASUREMENT_VIEW_FLAG.key, MFS_MEASUREMENT_VIEW_FLAG.objectKey)
  return data === true
}
